/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProjectHeader_psProject$ref: FragmentReference;
declare export opaque type ProjectHeader_psProject$fragmentType: ProjectHeader_psProject$ref;
export type ProjectHeader_psProject = {|
  +name: ?string,
  +psProgram: ?{|
    +id: string,
    +name: ?string,
    +color: ?string,
    +prefix: ?string,
    +isViewerProgramMember: ?boolean,
  |},
  +$refType: ProjectHeader_psProject$ref,
|};
export type ProjectHeader_psProject$data = ProjectHeader_psProject;
export type ProjectHeader_psProject$key = {
  +$data?: ProjectHeader_psProject$data,
  +$fragmentRefs: ProjectHeader_psProject$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectHeader_psProject",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProgramType",
      "kind": "LinkedField",
      "name": "psProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "prefix",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isViewerProgramMember",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectServiceProjectType"
};
})();
// prettier-ignore
(node/*: any*/).hash = '94bf9c398a5600571303acdc8d6f62a8';

module.exports = node;
